import {ExternalFilterField} from './ExternalFilterField';


export class ExternalFilter{
  SalesPersonCode: string;
  ViewName: string;
  SortField: string;
  IsAscending: boolean;
  FilterFields: ExternalFilterField[];
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/ExternalFilter.ts